<template>
  <b-form @submit="onSubmit">
    <b-col class="col-content">

      <b-form-group :label="$t('privatePage.testsuite_type')" style="margin-bottom: 30px;">
        <b-form-radio-group v-model="selectedTestType"
                            :options="testTypeOptions"
                            buttons
                            button-variant="outline-secondary"
                            name="testType" />
      </b-form-group>

      <b-card :header="$t('privatePage.testsuite_tests')" class="testsuiteCard">
        <b-form-group id="addTests" style="margin-bottom: 0px;">
            <b-row style="margin-bottom: 30px;">
              <b-col>
                <b-card :header="$t('privatePage.standard_testmethods')" style="background-color: #f5f4f4">
                  <b-form-select style="margin-bottom: 1rem;" :options="showStandardTestMethods()" v-on:change="onStandardMethodSelected" value-field="id" text-field="name" placeholder="Choose a test method..." />
                </b-card>
              </b-col>
            <b-col>
              <b-card :header="$t('privatePage.my_testmethods')" style="background-color: #f5f4f4">
                <b-form-select style="margin-bottom: 1rem;" :options="customerTestMethods" v-on:change="onCustomerMethodSelected" value-field="id" text-field="name" />
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card :header="$t('privatePage.testsuite_included_testmethods')" style="background-color: #f5f4f4">
                <b-list-group>
                  <b-list-group-item v-for="(method, methodIndex) in selectedTestMethods" :key="method.id" class="d-flex justify-content-between align-items-center">
                    {{ method.name }}
                  <b-button variant="danger" class="fa fa-trash" @click.stop="onDeleteFromList(selectedTestMethods, methodIndex)" />
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-form-group>
      </b-card>

      <b-card :header="$t('privatePage.testsuite_info')" class="testsuiteCard">
        <b-form-group id="addTests" style="margin-bottom: 0px;">
          <b-row>
            <b-col class="col-lg-6">
              <span>
                {{$t('privatePage.testsuite_expiration_date')}}
              </span>
              <b-form-input type="date" style="margin-bottom: 1rem;" v-model="expireDate" />
            </b-col>
          </b-row>
          <b-card :header="$t('privatePage.testsuite_group_customer')" style="background-color: #f5f4f4">
            <span>
              {{$t('privatePage.testsuite_customer_load_from_list')}}
            </span>
            <b-row>
              <b-col class="col-lg-6" v-show="isAddingCustomerTag || isUpdatingCustomerTag">
                <b-form-input type="text" v-model="customerTagEdited.name" id="customerTagInput" ref="customerTagInputRef"></b-form-input>
              </b-col>
              <b-col class="col-lg-6" v-show="!(isAddingCustomerTag || isUpdatingCustomerTag)">
                <b-form-select :options="customerTags" value-field="id" text-field="name" v-model="selectedCustomerTag">
                </b-form-select>
              </b-col>
              <b-button v-show="isAddingCustomerTag || isUpdatingCustomerTag" variant="primary" class="fa fa-check" style="width: 34px; height: 34px; margin-right: 5px; padding: 0px;" @click="onCustomerTagChange"></b-button>
              <b-button v-show="isAddingCustomerTag || isUpdatingCustomerTag" variant="danger" class="fa fa-times" style="width: 34px; height: 34px;" v-model="customerTags" @click.stop="onDeleteCustomerTag"></b-button>
              <b-button v-show="!(isAddingCustomerTag || isUpdatingCustomerTag)" variant="primary" class="fa fa-plus" style="width: 34px; height: 34px; margin-right: 5px;" @click.stop="onAddCustomerTag"></b-button>
              <b-button v-show="!(isAddingCustomerTag || isUpdatingCustomerTag)" variant="primary" class="fa fa-edit" style="width: 34px; height: 34px; margin-right: 5px; padding-top: 8px;" @click.stop="onUpdateCustomerTag"></b-button>
              <b-button v-show="!(isAddingCustomerTag || isUpdatingCustomerTag)" variant="danger" class="fa fa-trash" style="width: 34px; height: 34px;" v-model="customerTags" @click.stop="onDeleteCustomerTag"></b-button>
            </b-row>
          </b-card>
        </b-form-group>
      </b-card>

      <b-card :header="$t('privatePage.testsuite_participants')" class="testsuiteCard">
        <b-form-group id="addTests" style="margin-bottom: 0px;">
          <b-row>
            <b-col v-show="selectedTestType === 'EMAIL'">
              <span>
                {{$t('privatePage.email')}}
              </span>
              <b-form-input type="email" style="margin-bottom: 1rem;" id="participantEmail"
                            ref="participantEmailRef"
                            v-model="participantEdited.email"
                            v-bind:class="{'is-invalid': this.participantEdited.attemptSubmit && this.invalidParticipantEmail}" />
              <span style="margin-bottom: 1rem;" class="invalid-feedback">{{$t('field_required_feedback')}}</span>
            </b-col>
            <b-col v-show="selectedTestType === 'PIN' || selectedTestType === 'ANONYMOUS'">
              <span>
                {{$t('privatePage.pin')}}
              </span>
              <b-form-input type="text" style="margin-bottom: 1rem;" id="participantPin"
                            v-model="participantEdited.pin"
                            v-bind:class="{'is-invalid': this.invalidParticipantPin}" />
              <span style="margin-bottom: 1rem;" class="invalid-feedback">{{$t('field_required_feedback')}}</span>
            </b-col>
            <b-col>
              <span>
                {{selectedTestType === 'ANONYMOUS' ? $t('privatePage.testsuite_alias') : $t('privatePage.first_name')}}
              </span>
              <b-form-input type="text" style="margin-bottom: 1rem;" id="participantFirstname"
                            v-model="participantEdited.firstname"
                            :maxlength="selectedTestType === 'ANONYMOUS' ? 6 : 50"
                            v-bind:class="{'is-invalid': this.participantEdited.attemptSubmit && this.invalidParticipantFirstname}"/>
              <span style="margin-bottom: 1rem;" class="invalid-feedback">{{$t('field_required_feedback')}}</span>
            </b-col>
            <b-col v-show="selectedTestType !== 'ANONYMOUS'">
              <span>
                {{$t('privatePage.last_name')}}
              </span>
              <b-form-input type="text" style="margin-bottom: 1rem;" id="participantLastname"
              v-model="participantEdited.lastname"
                            v-bind:class="{'is-invalid': this.participantEdited.attemptSubmit && this.invalidParticipantLastname}" />
              <span style="margin-bottom: 1rem;" class="invalid-feedback">{{$t('field_required_feedback')}}</span>
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 30px;">
            <b-col class="col-lg-6">
              <b-button @click.stop="onAddParticipant">{{ $t('privatePage.testsuite_add_participant') }}</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card :header="$t('privatePage.testsuite_added_participants')" style="background-color: #f5f4f4">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center"
                                    v-for="(participant, participantIndex) in participants" :key="participant.pin">
                  <span v-show="selectedTestType === 'EMAIL'">{{participant.email}}</span>
                  <span v-show="selectedTestType === 'PIN' || selectedTestType === 'ANONYMOUS'">{{participant.pin}}</span>
                  <span>{{participant.firstname}}</span>
                  <span v-show="selectedTestType !== 'ANONYMOUS'">{{participant.lastname}}</span>
                  <b-button variant="danger" class="fa fa-trash" @click.stop="onDeleteFromList(participants, participantIndex)"></b-button>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-form-group>
      </b-card>

        <b-card :header="$t('privatePage.testsuite_email')" v-show="selectedTestType === 'EMAIL'">
          <b-row>
          <b-col>

            <b-row>
              <b-col>
                <b-card :header="$t('privatePage.testsuite_email_message')" style="background-color: #f5f4f4">
                  <span v-show="isAddingMailTemplate">
                    {{$t('name')}}
                  </span>
                  <span v-show="!isAddingMailTemplate">
                    {{$t('privatePage.testsuite_load_email_template')}}
                  </span>
                  <b-row style="margin-bottom: 15px;">
                    <b-col class="col-lg-6" v-show="isAddingMailTemplate">
                      <b-form-input
                        type="text"
                        v-model="mailTemplateName"
                        id="mailTemplateInput"
                        ref="mailTemplateInputRef"
                      />
                    </b-col>
                    <b-col class="col-lg-6" v-show="!(isAddingMailTemplate)">
                      <b-form-select
                        :options="mailTemplates"
                        value-field="id"
                        text-field="templateName"
                        v-model="selectedMailTemplateId"
                        :disabled="busyFetching"
                      />
                    </b-col>
                    <b-button
                      v-show="!isAddingMailTemplate && !busyFetching"
                      variant="primary"
                      class="fa fa-plus"
                      style="width: 34px; margin-right: 5px;"
                      @click.stop="onAddMailTemplate"
                    />
                    <b-button
                      v-show="!isAddingMailTemplate && selectedMailTemplateId && !busyFetching"
                      variant="danger"
                      class="fa fa-trash"
                      style="width: 34px;"
                      @click.stop="onDeleteMailTemplate"
                    />
                  </b-row>
                  <b-row v-show="isAddingMailTemplate || selectedMailTemplateId">
                    <b-col>
                    <span>
                      {{$t('privatePage.testsuite_email_subject')}}
                    </span>
                    <b-form-input style="margin-bottom: 1rem;" v-model="mailTemplateSubject" />
                    <span>
                      {{$t('privatePage.testsuite_email_message')}}
                    </span>
                    <vue-editor id="emailMessageEditor" v-model="mailTemplateBody"></vue-editor>
                    </b-col>
                  </b-row>
                  <b-row v-show="isAddingMailTemplate || isUpdatingMailTemplate || selectedMailTemplateId">
                    <b-col>
                      <b-form-group class="mt-2">
                        <b-button variant="primary" class="me-1" @click.stop="onMailTemplateSave">{{$t('save')}}</b-button>
                        <b-button variant="danger" class="me-1" @click.stop="onMailTemplateClear">{{$t('reset')}}</b-button>
                        <b-button variant="danger" @click.stop="onMailTemplateCancel">{{$t('cancel')}}</b-button>
                      </b-form-group>
                    </b-col>
                  </b-row>
              </b-card>
            </b-col>
          <b-col class="col-lg-4">
          <b-card :header="$t('privatePage.testsuite_email_possible_tags')" style="background-color: #f5f4f4">
            <b-row>
              <b-col>
                <span>{firstname}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span>{lastname}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span>{link}</span>
              </b-col>
            </b-row>
          </b-card>
          </b-col>
          </b-row>
          </b-col>
          </b-row>
        </b-card>

        <b-form-group style="margin-top: 2rem; margin-bottom: 4rem;">
          <b-button type="submit">{{ $t('privatePage.testsuite_create') }}</b-button>
        </b-form-group>

      </b-col>
    </b-form>
  </template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { VueEditor } from 'vue3-editor'
import editorFuncs from '../../components/scales/questions/questioneditorfuncs'
import misc from '../../js/helpers/misc'

function selectInCollection(id, sourceCollection, destCollection) {
  if (destCollection.filter(t => t.id === id).length > 0) {
    return
  }

  let target = sourceCollection.filter(q => q.id === id)
  if (target.length > 0) {
    destCollection.push(target[0])
  }
}

let date = new Date()
date.setDate(date.getDate() + 14)
let dateString = date.toLocaleDateString('sv-SE').replace(/[^ -~]/g, '')

export default {
  components: {
    VueEditor
  },
  name: 'test-suite-editor',
  data() {
    return {
      busyFetching: Boolean,
      selectedTestMethods: [],
      participants: [],
      participantEdited: {
        pin: misc.generatePin(),
        email: '',
        firstname: '',
        lastname: '',
        attemptSubmit: false
      },
      customerTagEdited: { id: '', name: '' },
      isAddingCustomerTag: false,
      isUpdatingCustomerTag: false,
      selectedCustomerTag: null,
      mailTemplates: [],
      isAddingMailTemplate: false,
      isUpdatingMailTemplate: false,
      selectedMailTemplateId: '',
      selectedMailTemplate: {},
      mailTemplateName: '',
      mailTemplateSubject: '',
      mailTemplateBody: '',
      selectedTestType: 'EMAIL',
      customerTagTempIndex: -1,
      expireDate: dateString
    }
  },
  computed: {
    ...mapGetters('userGroupsModule', ['customerTags']),
    ...mapGetters(['userId', 'settings']),
    testTypeOptions: function() {
      return [
        { text: this.$t('privatePage.testsuite_email'), value: 'EMAIL' },
        {
          text: this.$t('privatePage.testsuite_at_place'),
          value: 'PIN'
        },
        {
          text: this.$t('privatePage.testsuite_anonymous'),
          value: 'ANONYMOUS'
        }
      ]
    },
    invalidParticipantEmail: function() {
      return this.participantEdited.email.trim().length === 0
    },
    invalidParticipantPin: function() {
      return this.participantEdited.pin.trim().length === 0
    },
    invalidParticipantFirstname: function() {
      return this.participantEdited.firstname.trim().length === 0
    },
    invalidParticipantLastname: function() {
      return this.participantEdited.lastname.trim().length === 0
    },
    unsavedParticipantInputEntered: function() {
      return (
        this.participantEdited.firstname.trim().length > 0 ||
        ((this.selectedTestType === 'EMAIL' ||
          this.selectedTestType === 'PIN') &&
          this.participantEdited.lastname.trim().length > 0) ||
        (this.selectedTestType === 'EMAIL' &&
          this.participantEdited.email.trim().length > 0)
      )
    }
  },
  methods: {
    ...mapActions('userGroupsModule', {
      getCustomerTags: 'getCustomerTags',
      addCustomerTag: 'addCustomerTag',
      updateCustomerTag: 'updateCustomerTag',
      deleteCustomerTag: 'deleteCustomerTag',
      getMailTemplates: 'getMailTemplates',
      addMailTemplate: 'addMailTemplate',
      updateMailTemplate: 'updateMailTemplate',
      deleteMailTemplate: 'deleteMailTemplate'
    }),
    ...mapActions({
      showErrorMessage: 'showErrorMessage',
      showSuccessMessage: 'showSuccessMessage'
    }),
    onSubmit: function(evt) {
      evt.preventDefault()
      let testMethods = []
      let expectedNrOfParticipants = this.participants.length

      if (
        this.unsavedParticipantInputEntered &&
        window.confirm(
          this.$t('privatePage.testsuite_unsaved_participants_feedback')
        )
      ) {
        this.onAddParticipant()
        expectedNrOfParticipants++
      }

      if (this.participants.length === 0) {
        this.showErrorMessage(
          this.$t('privatePage.testsuite_no_participants_feedback')
        )
        return
      }

      if (this.participants.length !== expectedNrOfParticipants) {
        this.showErrorMessage(
          this.$t('privatePage.testsuite_invalid_participant_feedback')
        )
        return
      }

      if (this.selectedTestType === 'EMAIL' && this.mailTemplateBody.indexOf('{link}') === -1) {
        this.showErrorMessage(this.$t('privatePage.testsuite_no_link_added'))
        return
      }

      if (this.selectedTestMethods) {
        this.selectedTestMethods.forEach(tm => {
          testMethods.push(tm.id)
        })
      }

      let data = {
        ownerId: this.userId,
        testType: this.selectedTestType,
        testMethods: testMethods,
        expireDate: this.expireDate,
        customerTagId: this.selectedCustomerTag,
        participants: this.participants,
        // Temp bugfix PSYTEST-232, hardcoded link to prod env as fallback. Should be investigated properly when time permits.
        testpath: this.settings.path_UserTest !== undefined
          ? `${this.settings.path_UserTest}#/introduction?testId=`
          : 'https://testsys.psytest.se/usertest/#/introduction?testId=',
        email: {
          subject: this.selectedMailTemplate.subject,
          body: this.mailTemplateBody
        }
      }

      this.$emit('onSubmit', data)
    },
    showStandardTestMethods() {
      let filteredTestMethods = []

      this.standardTestMethods.forEach(tm => {
        if (tm.normGroups.filter(n => n.selected).length > 0) {
          filteredTestMethods.push(tm)
        }
      })

      return filteredTestMethods
    },
    onStandardMethodSelected: function(id) {
      selectInCollection(id, this.standardTestMethods, this.selectedTestMethods)
    },
    onCustomerMethodSelected: function(id) {
      selectInCollection(id, this.customerTestMethods, this.selectedTestMethods)
    },
    onDeleteFromList(collection, index) {
      editorFuncs.deleteObjectFromCollection(collection, index)
    },
    onAddParticipant() {
      let usePin = this.selectedTestType === 'PIN'
      let useEmail = this.selectedTestType === 'EMAIL'
      let useAnonymous = this.selectedTestType === 'ANONYMOUS'
      let pin = this.participantEdited.pin.trim()
      let email = this.participantEdited.email.trim()
      let firstname = this.participantEdited.firstname.trim()
      let lastname = this.participantEdited.lastname.trim()

      this.participantEdited.attemptSubmit = true

      if (usePin && pin.length === 0) {
        return
      }

      if (useEmail) {
        if (email.length === 0) {
          return
        }

        let emailRef = this.$refs.participantEmailRef
        if (!emailRef.$el.reportValidity()) {
          return
        }
      }

      if (firstname.length === 0) {
        return
      }

      if (!useAnonymous && lastname.length === 0) {
        return
      }

      this.participants.push({
        pin: pin,
        email: email,
        firstname: firstname,
        lastname: lastname
      })

      this.participantEdited.email = ''
      this.participantEdited.pin = misc.generatePin()
      this.participantEdited.firstname = ''
      this.participantEdited.lastname = ''
      this.participantEdited.attemptSubmit = false
    },
    onAddCustomerTag() {
      this.isAddingCustomerTag = true
      this.isUpdatingCustomerTag = false

      let tagInput = this.$refs.customerTagInputRef
      this.customerTagEdited = { id: '', name: '' }

      if (tagInput) {
        this.$nextTick(() => {
          tagInput.$el.focus()
        })
      }
    },
    onUpdateCustomerTag() {
      this.isAddingCustomerTag = false
      this.isUpdatingCustomerTag = true

      let selectedTag = this.customerTags.filter(
        t => t.id + '' === this.selectedCustomerTag + ''
      )

      if (selectedTag.length > 0) {
        this.customerTagEdited = selectedTag[0]
      }

      let tagInput = this.$refs.customerTagInputRef

      if (tagInput) {
        this.$nextTick(() => {
          tagInput.$el.focus()
        })
      }
    },
    onCustomerTagChange() {
      if (this.isAddingCustomerTag) {
        this.addCustomerTag({
          name: this.customerTagEdited.name
        })
          .then(tag => {
            this.customerTagEdited = tag
            this.selectedCustomerTag = tag.id
            this.isAddingCustomerTag = false
            this.isUpdatingCustomerTag = false
            this.showSuccessMessage(this.$t('save_ok_feedback'))
          })
          .catch(error => {
            this.isAddingCustomerTag = false
            this.isUpdatingCustomerTag = false
            this.showErrorMessage(error)
          })
      } else {
        this.updateCustomerTag(this.customerTagEdited)
          .then(tag => {
            this.customerTagEdited = tag
            this.selectedCustomerTag = tag.id
            this.isAddingCustomerTag = false
            this.isUpdatingCustomerTag = false
            this.showSuccessMessage(this.$t('save_ok_feedback'))
          })
          .catch(error => {
            this.isAddingCustomerTag = false
            this.isUpdatingCustomerTag = false
            this.showErrorMessage(error)
          })
      }
    },
    onDeleteCustomerTag() {
      this.deleteCustomerTag({ id: this.selectedCustomerTag })
        .then(() => {
          this.isAddingCustomerTag = false
          this.isUpdatingCustomerTag = false
          this.showSuccessMessage(
            this.$t('privatePage.customerTag_message')
          )
        })
        .catch(error => {
          this.isAddingCustomerTag = false
          this.isUpdatingCustomerTag = false
          this.showErrorMessage(error)
        })
    },
    getAllMailTemplates() {
      this.busyFetching = true
      this.getMailTemplates().then(response => {
        this.mailTemplates = response
        this.busyFetching = false
      })
    },
    onAddMailTemplate() {
      this.isAddingMailTemplate = true
      this.mailTemplateName = ''
      this.mailTemplateSubject = ''
      this.mailTemplateBody = ''
    },
    onDeleteMailTemplate() {
      this.deleteMailTemplate({ id: this.selectedMailTemplateId })
        .then(() => {
          this.isAddingMailTemplate = false
          this.isUpdatingMailTemplate = false
          this.selectedMailTemplateId = ''
          this.selectedMailTemplate.subject = ''
          this.selectedMailTemplate.body = ''
          this.showSuccessMessage(
            this.$t('privatePage.testsuite_email_template_deleted')
          )
        })
        .catch(error => {
          this.isAddingMailTemplate = false
          this.isUpdatingMailTemplate = false
          this.showErrorMessage(error)
        })
    },
    onMailTemplateSave() {
      if (this.isAddingMailTemplate) {
        this.addMailTemplate({
          templateName: this.mailTemplateName,
          subject: this.mailTemplateSubject,
          body: this.mailTemplateBody
        })
          .then(mailTemplate => {
            this.selectedMailTemplateId = mailTemplate.id
            this.selectedMailTemplate.subject = mailTemplate.subject
            this.selectedMailTemplate.body = mailTemplate.body
            this.isAddingMailTemplate = false
            this.isUpdatingMailTemplate = false
            this.showSuccessMessage(this.$t('save_ok_feedback'))
            this.getAllMailTemplates()
          })
          .catch(error => {
            this.isAddingMailTemplate = false
            this.isUpdatingMailTemplate = false
            this.showErrorMessage(error)
          })
      } else {
        this.updateMailTemplate({
          id: this.selectedMailTemplateId,
          templateName: this.selectedMailTemplate.templateName,
          subject: this.mailTemplateSubject,
          body: this.mailTemplateBody
        })
          .then(mailTemplate => {
            this.selectedMailTemplateId = mailTemplate.id
            this.selectedMailTemplate.subject = mailTemplate.subject
            this.selectedMailTemplate.body = mailTemplate.body
            this.isAddingMailTemplate = false
            this.isUpdatingMailTemplate = false
            this.showSuccessMessage(this.$t('save_ok_feedback'))
            this.getAllMailTemplates()
          })
          .catch(error => {
            this.isAddingMailTemplate = false
            this.isUpdatingMailTemplate = false
            this.showErrorMessage(error)
          })
      }
    },
    onMailTemplateClear() {
      this.mailTemplateName = this.selectedMailTemplate.name
      this.mailTemplateSubject = this.selectedMailTemplate.subject
      this.mailTemplateBody = this.selectedMailTemplate.body
    },
    onMailTemplateCancel() {
      this.selectedMailTemplate = {}
      this.selectedMailTemplateId = ''
      this.mailTemplateName = ''
      this.mailTemplateSubject = ''
      this.mailTemplateBody = ''
      this.isUpdatingMailTemplate = false
      this.isAddingMailTemplate = false
    }
  },
  props: {
    standardTestMethods: {},
    customerTestMethods: {}
  },
  watch: {
    selectedMailTemplateId() {
      if (this.selectedMailTemplateId) {
        this.selectedMailTemplate = this.mailTemplates.filter(
          mailTemplate => mailTemplate.id === this.selectedMailTemplateId
        )[0]
        this.mailTemplateSubject = this.selectedMailTemplate.subject
        this.mailTemplateBody = this.selectedMailTemplate.body
      }
    },
    mailTemplateSubject() {
      this.isUpdatingMailTemplate = Object.keys(this.selectedMailTemplate).length && (this.mailTemplateSubject !== this.selectedMailTemplate.subject)
    },
    mailTemplateBody() {
      this.isUpdatingMailTemplate = Object.keys(this.selectedMailTemplate).length && (this.mailTemplateBody !== this.selectedMailTemplate.body)
    }
  },
  created() {
    this.getAllMailTemplates()
  }
}
</script>

<style scoped>
.testsuiteCard {
  margin-bottom: 30px;
}
</style>
